import { render, staticRenderFns } from "./detalleCupon.vue?vue&type=template&id=90571e48&scoped=true&"
import script from "./detalleCupon.vue?vue&type=script&lang=js&"
export * from "./detalleCupon.vue?vue&type=script&lang=js&"
import style0 from "./detalleCupon.vue?vue&type=style&index=0&id=90571e48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90571e48",
  null
  
)

export default component.exports